import { React, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

export default function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((authUser) => {
      setIsAuthenticated(!!authUser);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  if (loading) {
    // You can return a loading spinner here if needed
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

